module.exports = __webpack_public_path__ + "img/userB23.647a3137.jpg";